import * as Common from 'components/common/Common'
import { KioskViewContainer, transparentCss } from 'components/common/Common'
import * as Typography from 'components/common/TypographyKiosk'
import FormSearchRoom from 'components/forms/FormSearchRoom'
import { useTranslation } from 'react-i18next'
import styled, { css, useTheme } from 'styled-components'

export const FormContainer = styled(Common.Div)(
  ({ theme: { params, spacing } }) => css`
    align-items: center;
    border-radius: ${params.buttonBorderRadius};
    display: flex;
    min-height: 120px;
    padding: ${spacing(4)} ${spacing(5)} ${spacing(2)};
    ${transparentCss};
  `
)

const ViewMakeReservationSearchRoomsKiosk = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <KioskViewContainer bgUrl={theme.assets.searchBackground}>
      <Typography.WelcomeHeader
        // mt={2}
        mb={2}
        align="center"
        tertiary
      >
        {t('findTheRoom.header')}
      </Typography.WelcomeHeader>
      <FormContainer>
        <FormSearchRoom />
      </FormContainer>
    </KioskViewContainer>
  )
}

export default ViewMakeReservationSearchRoomsKiosk
